

import axios from 'axios';
import { setCommonRefreshAction, setLogoutAction } from 'common/commonRedux/auth/actions';
import { authSlice } from 'common/commonRedux/auth/slice';
import { filterData } from 'common/commonRedux/feature/filteringSlice';
import dayjs from 'dayjs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BASE_URL } from 'common/config/baseUrl';
const { setLogin } = authSlice.actions
type PropsType = {
  employeeId?: string | undefined;
  urlObjKey: string;
  inView: any;
  type: "social" | "console" | "email" | "chat" | "image" | "meeting";
  enabled?: boolean;
};
const useInfiniteScrollForMonitoring = ({
  employeeId,
  urlObjKey,
  inView,
  type,
  enabled = true,
}: PropsType) => {
  const [newData, setNewData] = useState<any>({ events: [] });
  const isFirstLoad = useRef(true);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 12 });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [requestKey, setRequestKey] = useState(0);

  const didMount = useRef(false);

  const intAccountId = useSelector(
    (state: any) => state.auth?.profileData?.tokenData?.accountid
  );
  const token = useSelector(
    (state: any) => state.auth?.profileData?.token
  );
  const refreshToken = useSelector(
    (state: any) => state.auth?.profileData?.refreshToken
  );
  const encodedRefreshToken = encodeURIComponent(refreshToken)
  const dispatch: any = useDispatch();
  const getFilterData = useSelector(filterData);
  const timeRange = getFilterData?.timeRange;
  const startTimeStr = timeRange?.[0] ? dayjs(timeRange[0]).format('HH:mm:ss') : '00:00:00';
  const endTimeStr = timeRange?.[1] ? dayjs(timeRange[1]).format('HH:mm:ss') : '23:59:59';

  const dateRangeStartStr = dayjs.utc(getFilterData?.dateRange?.[0]).format('YYYY-MM-DD');
  const dateRangeEndStr = dayjs.utc(getFilterData?.dateRange?.[1]).format('YYYY-MM-DD');

  // const startDate = dayjs.utc(`${dateRangeStartStr}T${startTimeStr}`).valueOf();
  // const endDate = dayjs.utc(`${dateRangeEndStr}T${endTimeStr}`).valueOf();

  const startDate = dayjs(`${dateRangeStartStr}T${startTimeStr}`).utc().valueOf();
  const endDate = dayjs(`${dateRangeEndStr}T${endTimeStr}`).utc().valueOf();


  // useEffect(() => {
  //   console.log("start time  = ", startTimeStr);
  //   console.log("end time  = ", endTimeStr);
  //   console.log("start date  = ", dateRangeStartStr);
  //   console.log("end date  = ", dateRangeEndStr);
  //   console.log(" after concatening start date  = ", startDate);
  //   console.log(" after concatening end date  = ", endDate);
  // }, [startTimeStr, endTimeStr, dateRangeStartStr, dateRangeEndStr]);



  const singleDateStart = Array.isArray(getFilterData?.singleDate)
    ? getFilterData?.singleDate?.[0]
    : getFilterData?.singleDate;
  const singleDateEnd = Array.isArray(getFilterData?.singleDate)
    ? getFilterData?.singleDate?.[1]
    : getFilterData?.singleDate;

  const singleDateStartStr = dayjs.utc(singleDateStart).format('YYYY-MM-DD');
  const singleDateEndStr = dayjs.utc(singleDateEnd).format('YYYY-MM-DD');

  const singleStartDate = dayjs.utc(`${singleDateStartStr}T${startTimeStr}`).valueOf();
  const singleEndDate = dayjs.utc(`${singleDateEndStr}T${endTimeStr}`).valueOf();

  const fetchData = useCallback(async () => {
    if (!enabled) return;
    if (isFirstLoad.current) {
      setIsLoading(true);
    }
    setError(null);
    const params = {
      page: pagination.current,
      per_page: pagination.pageSize,
      start_at: getFilterData?.isSingleDate ? singleStartDate : startDate,
      end_at: getFilterData?.isSingleDate ? singleEndDate : endDate,
      emp_id: getFilterData?.clientIdString || employeeId,
      emp_name: getFilterData?.searchValue,
      dep_id: getFilterData?.departmentId,
      acc_id: intAccountId,
      type: type,
      ...(getFilterData?.projectId && { project_id: getFilterData.projectId }),
      // ...(getFilterData?.milestoneId && { milestone_id: getFilterData.milestoneId }),
      ...(getFilterData?.taskId && { task_id: getFilterData.taskId }),
    };
    // Build query string
    const queryString = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryString.append(key, String(value));
      }
    });
    try {
      let response = await fetch(
        `${process.env.REACT_APP_RUST_API_URL}/${urlObjKey}?${queryString}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      // If 401 → try refresh token
      if (response.status === 401) {
        try {
          const res = await axios.get(
            `${BASE_URL}/api/Auth/RefreshToken?token=${encodedRefreshToken}`,
          );
          if (res.data?.token) {
            // Update token in state/store
            dispatch(setLogin({ token: res.data.token }));

            // Retry original request with new token
            response = await fetch(
              `${process.env.REACT_APP_RUST_API_URL}/${urlObjKey}?${queryString}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${res.data.token}`,
                },
              }
            );
          } else {
            dispatch(setLogoutAction());
            throw new Error("Refresh token failed, logging out");
          }
        } catch (refreshError) {
          dispatch(setLogoutAction());
          throw new Error("Refresh token failed, logging out");
        }
      }
      // Check other HTTP errors
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setNewData((prev: any) => ({
        events:
          pagination.current === 1
            ? data?.data?.events
            : [...prev?.events, ...data?.data?.events],
      }));

      if (data?.data?.events?.length === pagination.pageSize) {
        setHasMoreData(true);
      } else {
        setHasMoreData(false);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch data');
      console.error('Fetch error:', err);
    } finally {
      // setIsLoading(false);
      if (isFirstLoad.current) {
        setIsLoading(false);
        isFirstLoad.current = false;
      }
    }
  }, [pagination, getFilterData, employeeId, urlObjKey, enabled]);

  // Fetch when enabled becomes true (row expands) or pagination/requestKey changes
  useEffect(() => {
    if (enabled) fetchData();
  }, [pagination.current, requestKey, enabled]);

  // Reset pagination and refetch when filters change
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    setNewData({ events: [] });
    setHasMoreData(true);
    isFirstLoad.current = true;

    setPagination({ current: 1, pageSize: 12 });
    setRequestKey((prev) => prev + 1); // 🔥 force refetch
  }, [getFilterData]);


  // Load more data when inView is true
  const loadMore = useCallback(() => {
    if (!isLoading && hasMoreData) {
      setPagination((prev) => ({ ...prev, current: prev.current + 1 }));
    }
  }, [isLoading, hasMoreData]);

  // Handle refresh action
  const handleRefresh = useCallback(() => {
    isFirstLoad.current = true;
    setNewData({ events: [] });
    setHasMoreData(true);
    setIsLoading(true);
    setPagination({ current: 1, pageSize: 12 });
    setRequestKey((prev) => prev + 1);
  }, []);



  // Set up refresh action in Redux
  useEffect(() => {
    dispatch(
      setCommonRefreshAction({
        CB: handleRefresh,
      })
    );
    return () => {
      dispatch(setCommonRefreshAction({}));
    };
  }, [dispatch, handleRefresh]);

  // Trigger loadMore when inView is true
  useEffect(() => {
    if (inView) {
      // setIsLoading(false)
      loadMore();
    }
  }, [inView, loadMore]);

  return {
    data: newData,
    hasMoreData,
    pagination,
    loadMore,
    isLoading,
    error,
    refresh: handleRefresh,
  };
};

export default useInfiniteScrollForMonitoring;
